import React, { Children } from 'react';
import PropTypes from 'prop-types';

import { Text, Paragraph } from 'components/core/Typography';
import { formatRatingsSummary } from '../../../utils/rating';
export default function ProsCons({ name, list = [] }) {
	return (
		<div className="pros-cons-section">
			<Paragraph size="small">{/* {name} */}</Paragraph>
			<ul className="pros-cons-list">
				{list.length ? (
					Children.toArray(
						list.map((item) => (
							<li className="quality-item">
								<Text weight="ultraBold" size="smaller" color="gray" className="pros-cons-item">
									{item.name}
									<Text weight="standard" color="gray" size="smaller" className="review-count">
										{item.value != null && `${formatRatingsSummary(item.value)}/5`}
									</Text>
								</Text>
								<div className="bar-container">
									<div
										data-testid={`${item.name}-bar`}
										className="bar"
										style={{
											width: `${parseInt(
												(item.value / 5) * 100
											)}%`,
										}}
									/>
								</div>
							</li>
						))
					)
				) : (
					<li>
						<Text>N/A</Text>
					</li>
				)}
			</ul>
		</div>
	);
}

ProsCons.propTypes = {
	name: PropTypes.string.isRequired,
	list: PropTypes.arrayOf(
		PropTypes.shape({
			name: PropTypes.string,
			reviewCount: PropTypes.number
		}),
	)
};

